<div class="app__discovery--widget--container">
  <div
    [style.border]="!hideDivider? '1px solid #53565B38': '0px solid #25508e !important'"
    [ngClass]="!hideDivider ? 'pt-8  mt-8' : 'pt-2  mt-0'"
    class="app__centered-item app__solid--border flex-col w-full h-auto bg-white border-[#53565B38] rounded-xl px-20  pb-2 ">
    <div>
      @if (!mobileDeliverPortal) {
        <p class="app__sub-title text-[#53565B]  font-semibold">
          <span class="font-bold text-[#25508E]"> Upload photos </span> from your <span class="font-bold text-[#25508E]"> mobile device </span>
        </p>
      }
      @if (mobileDeliverPortal) {
        <p class="app__sub-title text-[#53565B] font-semibold">
          <span class="font-bold text-[#25508E]"> Use this link </span>to access the mobile delivery portal
        </p>
      }

      <p class="app__sub-title text-[#18191C] text-sm mt-4 mb-7">
        We’ll text you a link that will take you straight to your mobile upload portal, or you can type it in manually on your mobile browser.
      </p>
      <div class="app__centered-item app__select--text--size mt-2">
        <form [formGroup]="collectionLinkForm">
          <div formGroupName="phone">
            <mat-form-field appearance="fill" class=" w-[380px] max-[480px]:w-full">
              <mat-label class="automtic-form-desing-lable">Select Country</mat-label>
              <mat-select formControlName="country" disableOptionCentering (selectionChange)="formatNumber()" required>
                @for (countryCode of filteredCountryCodes; track countryCode) {
                  <mat-option [value]="countryCode.code">
                    {{ countryCode.country }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div formGroupName="phone" class="mt-[-10px]">
            <mat-form-field appearance="fill" class=" w-[380px] max-[480px]:w-full">
              <mat-label class="automtic-form-desing-lable"> Phone Number </mat-label>
              <input
                formControlName="number"
                type="tel"
                placeholder="Telephone"
                (input)="formatNumber()"
                [errorStateMatcher]="phoneErrorMatcher"
                matInput
                required
                />
              </mat-form-field>
            </div>

            <div class="app__copy--link--box app__centered-item justify-between mt-[-10px] px-4">
              <span class="app__copy--link--text">{{ collectionLink }}</span>
              <span
                class="app__form--attribute--title flex text-[14px] text-[#25508e] hover:cursor-pointer"
                (click)="copyCollectionLink(collectionLink)"
                >
                <img src="assets/images/copy-link.svg" />
                COPY
              </span>
              <ng-template #collectionLinkPlaceholder>
                <div class="ph-item" style="padding: 0px !important; width: 99%; background-color: white; height: 100%; border: 0px">
                  <div class="ph-col-12" style="padding: 12px 17px !important">
                    <div class="ph-row">
                      <div class="ph-col-12 big"></div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </div>

            <div class="app__centered-item mt-8">
              <div>
                <button
                  class="w-[164px] m-0 p-0 h-11 hover:cursor-pointer"
                [class]="
                  !(phoneGroup.valid && this.collectionLinkForm.get('phone.number').valid) || isCollectionLinkSent
                    ? 'app__btn--disabled pointer-events-none text-[14.5px] font-medium'
                    : 'app__btn--primary items-center text-[14.5px] font-medium'
                "
                  (click)="sendCollectionLink()"
                  >
                  <span> {{ isCollectionLinkSent ? 'Link Sent!' : 'Send me the link' }} </span>
                </button>
                <p class="app__sub-title font-semibold text-[12px] text-[#898f9e] leading-[16px] mt-3">
                  Did not receive Link? <span class="font-bold text-[#25508E]" (click)="sendCollectionLink()"> Resend</span>
                </p>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  @if (!hideDivider) {
    <mat-divider class="mat-divider m-0 sm:mb-6 sm:mt-[42px]" aria-orientation="horizontal"></mat-divider>
  }
  @if (!hideDivider) {
    <div class="flex items-start justify-between w-full h-[65px] pl-0 pr-0 max-[480px]:pt-4">
      <button class="app__centered-item bg-transparent font-bold text-xs gap-2 cursor-pointer" (click)="handleSteps('backward')">
        <span class="app__centered-item gap-2 text-[#18191C]"
          ><span class="material-icons text-base"> arrow_back</span> <span class="text-sm font-semibold"> Back</span></span
          >
        </button>
        <div class="w-[158px]">
          <button
            class="app__btn--primary mt-0 max-[480px]:items-center max-[480px]:h-[38px] max-[480px]:m-0"
            type="submit"
            (click)="handleSteps('forward')"
            >
            Continue
          </button>
        </div>
      </div>
    }
